




export const ENABLE_DRAFT_ORDER_NUMBER_DECOUPLING = false;
